import React from "react";
import {
	ShareDownloadsButtonsContainer,
	ShareDownloadsPageWrapper,
} from "@insightfulscience/atomic-react/r1/molecules/ShareDownloads";
import { subscriptionPropTypes } from "../graphql/queries/getSubscriptionsList";
import ShareDownloadsLinks from "./ShareDownloadsLinks";
import ShareDownloadsMinVersion from "./ShareDownloadsMinVersion";
import ShareDownloadsSubscriptionInfo from "./ShareDownloadsSubscriotionInfo";

function ShareDownloadsInfo({ serialNumber }) {
	const productVersion = serialNumber.downloads[0].release || "";
	const { downloads } = serialNumber;
	return (
		<ShareDownloadsPageWrapper>
			<ShareDownloadsSubscriptionInfo serialNumber={serialNumber} />
			<ShareDownloadsButtonsContainer>
				<ShareDownloadsLinks items={downloads} productVersion={productVersion} />
			</ShareDownloadsButtonsContainer>
			<ShareDownloadsMinVersion items={downloads} />
		</ShareDownloadsPageWrapper>
	);
}

ShareDownloadsInfo.propTypes = {
	serialNumber: subscriptionPropTypes,
};

export default ShareDownloadsInfo;
